import { AssetMetadataUpload } from '@/asset/components/asset-metadata-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AssetMetadataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Update asset metadata</DialogTitle>
      <DialogContent dividers>
        <AssetMetadataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
